// extracted by mini-css-extract-plugin
export default {"cardContainer":"OpenDDA_cardContainer__BrouM","termsLink":"OpenDDA_termsLink__jF+Sr","skeletonLoadingAnimation":"OpenDDA_skeletonLoadingAnimation__qeBPs"};